/* jshint esversion: 11 */
// universalnav.min.js calls window[passedInDataLayer2].push(...), so
// passedInDataLayer2 must be a string key that points to an array on window.
const universalNavDataLayerKey = 'passedInDataLayer';

globalThis.passedInDataLayer2 =
  globalThis.passedInDataLayer2 || universalNavDataLayerKey;

if (!Array.isArray(globalThis[globalThis.passedInDataLayer2])) {
  globalThis[globalThis.passedInDataLayer2] = [];
}

(function () {
  const cspNonceEl = document.querySelector('[ngCspNonce]');
  const cspNonce = cspNonceEl ? cspNonceEl.getAttribute('ngCspNonce') : '';

  if (cspNonce) {
    const originalCreateElement = document.createElement.bind(document);
    document.createElement = function (tagName, options) {
      const element = originalCreateElement(tagName, options);
      if (tagName.toLowerCase() === 'style') {
        element.nonce = cspNonce;
      }
      return element;
    };

    const cspSheet = document.createElement('style');
    (document.head || document.documentElement).appendChild(cspSheet);

    const managedHtmlAttr = 'data-csp-managed-html';
    const styleMap = {};
    let classId = 0;

    function addCspRule(cls, cssText) {
      try {
        cspSheet.sheet.insertRule(
          '.' + cls + '{' + cssText + '}',
          cspSheet.sheet.cssRules.length
        );
      } catch (error) {
        let fallbackRule = '.' + cls + '{' + cssText + '}';
        if (error?.message) {
          fallbackRule += '/* insertRule fallback: ' + error.message + ' */';
        }
        cspSheet.appendChild(document.createTextNode(fallbackRule));
      }
    }

    function getOrCreateClass(styleVal) {
      let cls = styleMap[styleVal];
      if (!cls) {
        cls = '_cspS' + classId++;
        styleMap[styleVal] = cls;
        addCspRule(cls, styleVal);
      }
      return cls;
    }

    function isManagedHtmlElement(element) {
      if (!(element instanceof Element)) {
        return false;
      }

      return (
        element.hasAttribute(managedHtmlAttr) ||
        Boolean(element.closest('[' + managedHtmlAttr + ']'))
      );
    }

    function upsertStyleClass(element, styleValue) {
      if (!styleValue) {
        return;
      }

      const previous = element.dataset.cspS;
      if (previous) {
        element.classList.remove(previous);
      }

      const cls = getOrCreateClass(styleValue);
      element.classList.add(cls);
      element.dataset.cspS = cls;
      element.removeAttribute('style');
    }

    function patchHTML(html, targetElement) {
      if (typeof html !== 'string') {
        return html;
      }

      html = html.replaceAll(
        /<style(?![^>]*nonce)(?=[\s>])/gi,
        '<style nonce="' + cspNonce + '"'
      );

      html = html.replaceAll(/<[a-z][^>]*>/gi, function (tag) {
        const styleRe = /\sstyle\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i;
        const match = styleRe.exec(tag);
        if (!match) {
          return tag;
        }

        let before = tag.substring(0, match.index);
        const after = tag.substring(match.index + match[0].length);
        const styleValue = match[1] || match[2] || match[3];
        const cls = getOrCreateClass(styleValue);

        if (/class\s*=\s*(['"])/i.test(before)) {
          before = before.replace(
            /class\s*=\s*(['"])([^'"]*)\1/i,
            'class="$2 ' + cls + '"'
          );
          return before + after;
        }

        return before + ' class="' + cls + '"' + after;
      });

      // Final safeguard: strip any remaining inline styles that the
      // class-conversion regex above didn't match.
      html = html.replaceAll(/\sstyle\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');

      return html;
    }

    const innerDesc = Object.getOwnPropertyDescriptor(
      Element.prototype,
      'innerHTML'
    );
    if (innerDesc?.set) {
      Object.defineProperty(Element.prototype, 'innerHTML', {
        set: function (value) {
          innerDesc.set.call(this, patchHTML(value, this));
        },
        get: innerDesc.get,
        configurable: true,
      });
    }

    const outerDesc = Object.getOwnPropertyDescriptor(
      Element.prototype,
      'outerHTML'
    );
    if (outerDesc?.set) {
      Object.defineProperty(Element.prototype, 'outerHTML', {
        set: function (value) {
          outerDesc.set.call(this, patchHTML(value, this));
        },
        get: outerDesc.get,
        configurable: true,
      });
    }

    const originalInsertAdjacentHTML = Element.prototype.insertAdjacentHTML;
    Element.prototype.insertAdjacentHTML = function (position, text) {
      return originalInsertAdjacentHTML.call(
        this,
        position,
        patchHTML(text, this)
      );
    };

    // Angular's DomSanitizer uses DOMParser.parseFromString() internally.
    // That path bypasses our innerHTML override, so the browser sees inline
    // style attributes and fires CSP style-src violations.  Patch the string
    // before it reaches the parser.
    // Note: Angular may wrap HTML in a TrustedHTML object, so we use
    // String() to coerce rather than checking typeof === 'string'.
    const originalParseFromString = DOMParser.prototype.parseFromString;
    DOMParser.prototype.parseFromString = function (string, type) {
      if (type === 'text/html' && string) {
        string = patchHTML(String(string), null);
      }
      return originalParseFromString.call(this, string, type);
    };

    function patchManagedSubtree(root) {
      if (!(root instanceof Element)) {
        return;
      }

      const managedRoots = [];
      if (root.hasAttribute(managedHtmlAttr)) {
        managedRoots.push(root);
      }

      root
        .querySelectorAll('[' + managedHtmlAttr + ']')
        .forEach(managedRoot => managedRoots.push(managedRoot));

      for (const managedRoot of managedRoots) {
        if (managedRoot.hasAttribute('style')) {
          upsertStyleClass(managedRoot, managedRoot.getAttribute('style'));
        }

        managedRoot.querySelectorAll('[style]').forEach(element => {
          upsertStyleClass(element, element.getAttribute('style'));
        });
      }
    }

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          const element = mutation.target;
          if (!isManagedHtmlElement(element)) {
            continue;
          }

          upsertStyleClass(element, element.getAttribute('style'));
          continue;
        }

        if (mutation.type !== 'childList') {
          continue;
        }

        mutation.addedNodes.forEach(node => {
          patchManagedSubtree(node);
        });
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    });

    patchManagedSubtree(document.documentElement);
  }

  // Load Military OneSource universal navigation script
  (function () {
    const scriptId = 'universalnav-js';
    const navContainerId = 'universalnav-navigation';

    function loadUniversalNavScript() {
      if (!document.getElementById(navContainerId)) {
        return false;
      }

      // Skip if already loaded
      if (document.getElementById(scriptId)) {
        return true;
      }

      const firstScript = document.getElementsByTagName('script')[0];
      const script = document.createElement('script');
      script.id = scriptId;
      script.src =
        'https://download.militaryonesource.mil/MOS/universalnav.min.js';
      if (cspNonce) {
        script.nonce = cspNonce;
      }
      firstScript.parentNode.insertBefore(script, firstScript);

      return true;
    }

    if (loadUniversalNavScript()) {
      return;
    }

    const navObserver = new MutationObserver(function () {
      if (loadUniversalNavScript()) {
        navObserver.disconnect();
      }
    });

    navObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
})();
